import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {LoginResponse} from "../../rest/jtmc/models/LoginResponse";
import {storageFunctions} from "../../storage";
import {LoginConfirmResponse} from "../../rest/jtmc/models/LoginConfirmResponse";
import {navigate, replace} from "../../refrences/RootNavigation";

interface state  {
    inputValue: string,
    phone: string,
    code: string,
    codeSent: boolean
}

interface props  {
    children: any
}

class LoginComponents extends FunctionDefinedComponents <props, state>  {

    constructor(props:any) {
        super(props);
        this.state = {
            inputValue: "",
            code: "",
            phone: "",
            codeSent: false
        }
    }

    successfulCodeSent(){
        this.appContext.snackBarData?.events?.success("کد ارسال شد")
        this.setState({
            codeSent: true,
            inputValue: ""
        });
    }

    login(){
        this.setState({phone: this.state.inputValue});
        this.fetch.Auth.requests.login({
            phone: this.state.phone,
            branch_id: this.appContext.branch
        }).then((res:LoginResponse)=> this.successfulCodeSent() );
    }

    guest(){
        this.fetch.Auth.requests.guest({}).then((res:LoginConfirmResponse)=>{
            storageFunctions.saveData("api_key", res.token).then(()=>{
                replace("Menu");
            });
        });
    }

    confirm(){
        this.setState({code: this.state.inputValue});
        this.fetch.Auth.requests.confirm({
            phone: this.state.phone,
            code: this.state.code
        }).then((res:LoginConfirmResponse)=>{
            storageFunctions.saveData("api_key", res.token).then(()=>{
                storageFunctions.saveData("user_phone_number", this.state.phone).then(()=>{
                    replace("Menu");
                });
            });
        });
    }

    back(){
        this.setState({
            inputValue: "",
            codeSent: false
        });
    }

    rolledChildren():RolledChildType{
        return [
            {
                role: "input",
                visible: true,
                props: {
                    value: this.state.inputValue,
                    placeholder: !this.state.codeSent ?
                        this.texts?.t("login.button_phone_ph"):
                        this.texts?.t("login.button_code_ph"),
                    onChangeText: (t:string) => {
                        this.setState({inputValue: t});

                        if(!this.state.codeSent)
                            this.setState({phone: t})
                        else
                            this.setState({code: t})
                    }
                },
                children: null,
            },
            {
                role: "main-button",
                visible: true,
                props: {
                    title: this.state.codeSent ?
                        this.texts?.t("login.button_confirm_code"):
                        this.texts?.t("login.button_send_code"),
                    onPress: () => {
                        if(!this.state.codeSent)
                            this.login();
                        else
                            this.confirm();
                    }
                },
                children: [],
            },
            {
                role: "back-button",
                visible: this.state.codeSent,
                props: {
                    onPress: () => {
                        this.back();
                    }
                },
                children: [],
            },
            {
                role: "guest-login",
                // @ts-ignore
                visible: this.context.orderType != "outside" && !this.state.codeSent,
                props: {
                    onPress: () => {
                        this.guest();
                    }
                },
                children: [],
            }
        ];
    }
}

export default LoginComponents;